export const cartKeys = {
   cart: ['shopify-cart'],
};

export enum CartError {
   EmptyCart = 'empty_cart',
   UnknownError = 'unknown_error',
}
